import {
    Treatments,
    MockedFeaturesMap,
} from '@splitsoftware/splitio/types/splitio';

// Instructions for editing:
// https://trustar.atlassian.net/wiki/spaces/EN/pages/293568588/How+to+Maintain+and+Configure+Splits+for+the+Station+Application

export const flags = {
    WF_APP_ENABLED: 'workflows_enabled',
    SHOW_SAFELIST_LIBRARIES: 'show_safelist_libraries_workflows',
};

export const treatments = {
    ON: 'on',
    OFF: 'off',
};

// These configurations are the settings for the Split server
// while it is operating in 'localhost' mode.
//
// See: https://help.split.io/hc/en-us/articles/360020448791-JavaScript-SDK#localhost-mode
export const localhostTreatments: MockedFeaturesMap = {
    [flags.WF_APP_ENABLED]: { treatment: treatments.ON, config: null },
    [flags.SHOW_SAFELIST_LIBRARIES]: { treatment: treatments.ON, config: null },
};

// These are the defaults for what will be injected into the
// Redux stores in a production-like setting.
export const defaultTreatments: MockedFeaturesMap = {
    [flags.WF_APP_ENABLED]: { treatment: treatments.OFF, config: null },
    [flags.SHOW_SAFELIST_LIBRARIES]: { treatment: treatments.ON, config: null },
};
